import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { GiftPassListRow } from '../../api/gift-passes';

import { formatPassDate, giftPassPath, maskedPassCode } from './gift-passes-model';
import { GiftPassOriginCell } from './GiftPassOriginCell';
import { GiftPassPurchaserCell } from './GiftPassPurchaserCell';
import { GiftPassStatusPill } from './GiftPassStatusPill';

const DATE_CELL = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
} as const;

/** The code's link is stretched over the whole row, so the row is one tab stop. */
export function GiftPassesTableRow({ row }: { row: GiftPassListRow }) {
  const code = maskedPassCode(row.codeMasked);
  return (
    <tr className="gp-table-row">
      <td style={{ paddingLeft: 18, whiteSpace: 'nowrap' }}>
        <Link
          to={giftPassPath(row.id)}
          className="nb-mono gp-row-link"
          aria-label={`Open gift pass ${code}`}
          style={{ fontSize: 12.5, letterSpacing: '.04em', color: 'inherit' }}
        >
          {code}
        </Link>
      </td>
      <td>
        <GiftPassPurchaserCell purchaser={row.purchaser} />
      </td>
      <td
        style={{
          fontSize: 12.5,
          color: row.recipientEmail ? 'var(--nb-ink)' : 'var(--nb-faint)',
        }}
      >
        {row.recipientEmail ?? '—'}
      </td>
      <td>
        <GiftPassOriginCell row={row} />
      </td>
      <td>
        <GiftPassStatusPill status={row.status} />
      </td>
      <td
        style={{
          fontSize: 12.5,
          color: 'var(--nb-muted)',
          whiteSpace: 'nowrap',
          paddingRight: 18,
        }}
      >
        <div style={DATE_CELL}>
          {formatPassDate(row.createdAt)}
          <ChevronRight size={14} aria-hidden style={{ color: 'var(--nb-faint)' }} />
        </div>
      </td>
    </tr>
  );
}
